import { useHistory, useParams } from "react-router-dom";

import { useCase } from "src/hooks/useCase";
import { Pane } from "src/components/Pane";
import { ScenarioCreatePage } from "./ScenarioCreatePage";
import { ScenarioEditPage } from "./ScenarioEditPage";

interface Props {}

export function ScenarioGeneralSettingsPage(props: Props) {
  const history = useHistory();
  const params = useParams<{ caseId: string; scenarioId: string }>();
  const { data: acase } = useCase(params.caseId);

  function handleClose() {
    if (!acase) return null;
    history.push(`/cases/${acase.id}`);
  }

  return render();

  function render() {
    if (params.scenarioId === "new") {
      return (
        <Pane>
          <ScenarioCreatePage onClose={handleClose} />
        </Pane>
      );
    }
    // else
    return (
      <Pane>
        <ScenarioEditPage key={`${params.caseId}-${params.scenarioId}`} onClose={handleClose} />
      </Pane>
    );
  }
}
